function SecurityScreen() {
  return (
    <section className="mx-auto w-full max-w-4xl">
      <article className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
        <h2 className="mb-2 text-3xl font-semibold text-slate-900">Security</h2>
        <p className="mb-2 text-sm text-slate-500">Last updated: February 23, 2026</p>

        <h4 className="mb-2 mt-5 text-lg font-semibold text-slate-900">Account Security</h4>
        <ul className="list-disc space-y-1 pl-5 text-sm leading-6 text-slate-700">
          <li>Password strength checks are enforced at registration.</li>
          <li>hCaptcha is required on signup to reduce automated abuse.</li>
          <li>Authentication-protected routes are enforced for user, creator, and admin actions.</li>
        </ul>

        <h4 className="mb-2 mt-5 text-lg font-semibold text-slate-900">Payment Security</h4>
        <ul className="list-disc space-y-1 pl-5 text-sm leading-6 text-slate-700">
          <li>Checkout is processed with Stripe; card data is handled by Stripe Elements.</li>
          <li>Server-side payment confirmation controls access-granting operations.</li>
          <li>Webhook signatures are validated to prevent forged payment events.</li>
          <li>Reconciliation tools detect and repair asynchronous payment inconsistencies.</li>
        </ul>

        <h4 className="mb-2 mt-5 text-lg font-semibold text-slate-900">Fraud and Abuse Controls</h4>
        <ul className="list-disc space-y-1 pl-5 text-sm leading-6 text-slate-700">
          <li>Rate limiting and velocity checks protect critical order and payment flows.</li>
          <li>Duplicate event/idempotency handling prevents repeated grants on retries.</li>
          <li>Self-purchase prevention and creator onboarding checks enforce marketplace integrity.</li>
        </ul>

        <h4 className="mb-2 mt-5 text-lg font-semibold text-slate-900">File Upload and Content Safety</h4>
        <ul className="list-disc space-y-1 pl-5 text-sm leading-6 text-slate-700">
          <li>Upload validation includes type checks, size limits, and request constraints.</li>
          <li>Optional malware scanning integration can quarantine suspicious files.</li>
          <li>Rejected uploads are cleaned up to reduce persistence risk.</li>
        </ul>

        <h4 className="mb-2 mt-5 text-lg font-semibold text-slate-900">Operational Monitoring</h4>
        <p className="text-sm leading-6 text-slate-700">
          Structured logs and alert scripts are used to track webhook failures, transfer failures,
          and reconciliation drift so payment operations remain observable and recoverable.
        </p>

        <h4 className="mb-2 mt-5 text-lg font-semibold text-slate-900">Analytics and Session Insight Controls</h4>
        <ul className="list-disc space-y-1 pl-5 text-sm leading-6 text-slate-700">
          <li>Google Analytics events only load after a user explicitly allows analytics.</li>
          <li>
            The heatmap/session-insight baseline is off by default and does not load unless it is
            enabled for launch and the user has also granted analytics consent.
          </li>
          <li>
            Tracking preferences can be revisited from the footer so non-essential telemetry stays
            under user control.
          </li>
        </ul>

        <h4 className="mb-2 mt-5 text-lg font-semibold text-slate-900">User Responsibilities</h4>
        <ul className="list-disc space-y-1 pl-5 text-sm leading-6 text-slate-700">
          <li>Use a strong, unique password and protect account credentials.</li>
          <li>Review account/purchase history regularly for unexpected activity.</li>
          <li>Report suspected compromise or fraud immediately to support.</li>
        </ul>

        <h4 className="mb-2 mt-5 text-lg font-semibold text-slate-900">Contact for Security Concerns</h4>
        <p className="text-sm leading-6 text-slate-700">
          If you notice suspicious account activity, payment issues, or anything that appears
          unsafe on the platform, contact{" "}
          <a
            href="mailto:contact@practidex.com"
            className="font-semibold text-sky-700 no-underline hover:text-sky-800"
          >
            contact@practidex.com
          </a>
          . Include the account email and a short description of the issue so the team can review
          it efficiently.
        </p>
      </article>
    </section>
  );
}

export default SecurityScreen;
